module.exports = __webpack_public_path__ + "static/media/c3bannerModulR_small.ab04bc3d.jpg";